module.exports = __webpack_public_path__ + "img/vue1-languette_rose.fe977361.png";